import { z } from 'zod';
/** Yazılı Kağıdı / Yaprak Test / Deneme */
export const PaperKindSchema = z.enum(['written', 'sheet', 'trial']);
export const PaperSizeSchema = z.enum(['a4', 'a5']);
export const PaperOrientationSchema = z.enum(['portrait', 'landscape']);
/**
 * Kağıt şablonları (Gencay Akademi rev.).
 * - `yaprak` / `yaprak_branded`: Yaprak test düzeni (KONU başlığı, 2 sütun).
 * - `yazili_1` / `yazili_2` / `yazili_3`: Klasik yazılı sınav kağıdı düzenleri.
 */
export const PaperTemplateSchema = z.enum([
    'yaprak',
    'yaprak_branded',
    'yazili_1',
    'yazili_2',
    'yazili_3',
]);
export const AnswerKeyModeSchema = z.enum(['qr', 'appendix', 'both']);
export const ChoiceLayoutSchema = z.enum(['vertical', 'horizontal']);
/** Visual density for mixed text / image questions (OTM-style). */
export const QuestionContentScaleSchema = z.enum(['small', 'medium', 'large']);
export const PaperSettingsSchema = z
    .object({
    paperKind: PaperKindSchema.default('written'),
    paperSize: PaperSizeSchema.default('a4'),
    orientation: PaperOrientationSchema.default('portrait'),
    columns: z.union([z.literal(1), z.literal(2)]).default(1),
    marginTopMm: z.number().min(5).max(40).default(15),
    marginBottomMm: z.number().min(5).max(40).default(15),
    marginLeftMm: z.number().min(5).max(40).default(15),
    marginRightMm: z.number().min(5).max(40).default(15),
    template: PaperTemplateSchema.default('yaprak'),
    watermarkEnabled: z.boolean().default(true),
    /** Brand mark only — always rendered as "G" in PDF. */
    watermarkText: z.string().max(80).default('G'),
    cropImages: z.boolean().default(false),
    showTeacherHeader: z.boolean().default(true),
    teacherName: z.string().max(120).default(''),
    teacherTitle: z.string().max(120).default(''),
    paperTitle: z.string().max(200).default(''),
    /** Yaprak test başlığındaki kısa konu etiketi (KONU rozeti). */
    topic: z.string().max(80).default(''),
    /** Yaprak test ilk sayfa "açıklama kısmı". */
    description: z.string().max(1000).default(''),
    includeOpticalForm: z.boolean().default(false),
    answerKeyMode: AnswerKeyModeSchema.default('both'),
    /** OTM-style: reorder questions to pack pages more tightly. */
    smartPlacement: z.boolean().default(true),
    choiceLayout: ChoiceLayoutSchema.default('vertical'),
    /** Optical form: add a BOŞ / blank bubble column. */
    includeBlankOption: z.boolean().default(true),
    showPageNumbers: z.boolean().default(true),
    /** Ad Soyad / No / Sınıf / Okul / Tarih blank rows on first page. */
    showStudentFields: z.boolean().default(true),
    schoolName: z.string().max(200).default(''),
    className: z.string().max(80).default(''),
    examDate: z.string().max(40).default(''),
    /** Preferred subject id order for multi-subject (trial) papers. */
    subjectOrder: z.array(z.string().max(64)).max(40).default([]),
    /** Unify text vs image question visual weight. */
    questionScale: QuestionContentScaleSchema.default('medium'),
    /** Extra vertical gap between question blocks (OTM-style). */
    spaceBetweenQuestions: z.boolean().default(false),
})
    .strict();
export const DEFAULT_PAPER_SETTINGS = PaperSettingsSchema.parse({});
export const PAPER_MAX_QUESTIONS = 15;
//# sourceMappingURL=paper-maker.js.map